<template>
<!-- <div><br> -->
<!-- <div style="margin-top:20px; text-align:justify;" v-if="activo==0"> -->
  <div class="columns"> 
    <div class="column is-9">
    <!-- <ul> -->

      <strong style="color:#992DCF; margin-top:9px; margin-left:10px; " v-text="this.tourInformation.data[0].nombre"></strong>
      <!-- <br v-if="tiposList==''"> -->
      <strong style="color:#C89D41; margin-top:9px; margin-left:10px;" v-text="this.tipoName"></strong>

      <div style="margin-left:10px; margin-bottom:5px;">
      <a class="button is-info is-outlined is-small" href="https://www.messenger.com/t/691083214335683/?messaging_source=source%3Apages%3Amessage_shortlink&source_id=1441792" target="_blank" >Facebook chat</a>
      </div>
      <br v-if="tiposList==''">
        
          <div v-if="tiposList!=''" class="is-size-7" style="margin-left:10px; margin-bottom:5px;">Seleccione una opción</div>
          <div v-if="tiposList!=''" class="tabs is-toggle is-toggle is-small"> 
            
            <ul>

              <div v-for="(tipo, index) in tiposList">
                <li @click="setTipo(tipo.id,index)" style="margin-left:10px;" :class="(subSelect == index) ? 'is-active' : '' ">
                  <a>
                    <span v-text="tipo.nombre"></span>
                  </a>
                </li>
              </div>

            </ul>
            
          </div>
          <div v-if="activo!=0" style="margin-left:10px;" > <b>{{tipoName}}</b> no disponible por el momento. </div>          
          <div  v-if="activo==0">
    <!-- </ul> -->
  

  <div style="margin-top:-20px;" >
    <span class="is-size-7" style="margin-left:10px;">El mejor servicio del Caribe Mexicano <strong style="font-size:15px;">Garantizado</strong> </span> 
    <br>
    <!--
    <span class="is-size-7" style="margin-left:10px;" v-if="this.tourInformation.data[0].id!=36 && this.tourInformation.data[0].operador_id!=2 ">Desde $<strong style="font-size:15px;" v-text="pagoMes"></strong>* MXN/mes </span> 
    <br>
    <span class="is-size-7" style="margin-left:10px;" v-if="this.tourInformation.data[0].id!=36 && this.tourInformation.data[0].operador_id!=2 "> Precio especial quintanarroense: $<strong v-text="publicAdultQroo"></strong> MXN </span> 
    -->
    <!-- <button class="button is-light is-small" href="index.html#cotizador" value="Solicitar en Facebook" target="_blank">Cotizar</button> -->
    
    <!-- <div class="column is-three-quarters"> -->
      <div style="background-color:#957AA0; color:white; text-align:center;" class="is-size-7" > <  Deslice para ver más fotos > </div>
    <div style="margin-top:-20px; background-color:#DCDCDC;">
      <carousel-3d v-if="carouselReady">
          <slide v-for="(file,num) in serviceImages" :index="num">
            <img :src="'https://'+host+'/services_images/'+file.nombre" style="height:100%important;" >
          </slide>
      </carousel-3d>
    </div>

    <div class="table-container"  style="margin-top:-20px; background-color:#957AA0;">
      <table class="table" style=" background-color:#957AA0; color:white; text-align:center;">
        <tbody>
          <tr>
            <td>Contacta a tu representate para obtener los méjores precios.</td>
              <!-- <td>Adulto</td> -->
              <!--
              <td align="center">Adulto $<b><span v-text="publicAdult"></span></b></td>
              -->
              <!-- <td>Menor</td> -->
               <!--
              <td align="center">Menor $<b><span v-text="publicMenor"></span></b></td>
              -->
              <!-- <td>Infante</td> -->
               <!--
              <td align="center">Infante $<b><span v-text="publicInfante"></span></b></td>
              <td align="center">Tarifas en MXN</td>
              -->
            
          </tr>
        </tbody>
      </table>
      
    </div>
    <font style="color:grey; margin-left:20px; margin-top:-10px; font-size:12px;">Las imágenes son propiedad del proveedor del servicio.</font>
  </div>
  <br>
  <div style="margin-left:10px; margin-right:10px;" class="columns">
    <div class="column">
      <strong style="color:#69BD59;">Descripción:</strong>
      <br>
      {{descripcion}}
      <!-- <textarea class="textarea" v-model="descripcion" placeholder="Descripción"></textarea> -->
    </div>
    <div class="column">
      <strong style="color:#69BD59;">Recomendaciones:</strong>
      <br>
      {{recomendaciones}}
            <!-- <textarea class="textarea" v-model="recomendaciones" placeholder="Recomendaciones"></textarea> -->
    </div>
  </div>

  <div style="margin-left:10px; margin-right:10px;" class="columns">
    <div class="column">
      <strong style="color:#69BD59;">Incluye:</strong>
      <br>
      {{incluye}}
      <!-- <textarea class="textarea" v-model="incluye" placeholder="Qué incluye"></textarea> -->
    </div>
    <div style="margin-left:10px; margin-right:10px;" class="column">
      <strong style="color:#69BD59;">No incluye:</strong>
      <br>
      {{noIncluye}}
      <!-- <textarea class="textarea" v-model="noIncluye" placeholder="No incluye"></textarea> -->
    </div>
  </div>

  <div style="margin-left:10px; margin-right:10px;" class="columns">
    <div class="column">
      <strong style="color:#69BD59;">Lugar de salida</strong>
      <br>
      {{lugarSalida}}
      <!-- <input class="input" v-model="lugarSalida"> -->
    </div>
    <div class="column">
      <!-- Hora de salida
      <input class="input" v-model="horaSalida" type="time" > -->

      <!-- <div class="field"> -->
        <strong style="color:#69BD59;">Hora de salida</strong>
        <br>
        {{horaSalida}}
        <!-- <vue-clock-picker class="time" mode="24" v-model="horaSalida"></vue-clock-picker> -->
      <!-- </div>
       -->
    </div>
  </div>
          </div>

  </div>

  <div  v-if="activo==0">
    
  <div style="background-color:#B588DF; margin-left:10px; margin-right:10px;" class="column is-fluid">
    
    <strong style="color:white;">¿Cuando te gustaría ir?</strong> <br> 
<!-- <div style="align:center;"> -->
    <date-pick v-if="fecha!=''" v-model="fecha"  :inputAttributes="{readonly: true}" :isDateDisabled="getAnticipacion" style="z-index:999;">
      
    </date-pick>
<!-- </div> -->

    <br>

      <table class="table is-fullwidth" style="background:#B588DF; margin-top: 10px;">
        <tbody>
          <tr>
            <td>

              
                <label><strong style="color:white;">Adultos y adolecentes (11 años y más)</strong></label>

            </td>
            <td align="center">

                <div v-if="dosPorUno==2" class="select">
                  <select v-model="adultos" @change="cotiza()" >
                    <option value=0>0</option>
                    <option value=1>1</option>
                    <option value=2>2</option>
                    <option value=3>3</option>
                    <option value=4>4</option>
                    <option value=5>5</option>
                    <option value=6>6</option>
                    <option value=7>7</option>
                    <option value=8>8</option>
                    <option value=9>9</option>
                    <option value=10>10</option>
                  </select>
                </div>

                <div v-if="dosPorUno==1" class="select">
                  <select v-model="adultos" @change="cotiza()" >
                    <option value=0>0</option>
                    <option value=2>2</option>
                    <option value=4>4</option>
                    <option value=6>6</option>
                    <option value=8>8</option>
                    <option value=10>10</option>
                  </select>
                </div>
              

            </td>
          </tr>
          <tr v-if="admiteNino==1">
            <td>
              
              
                <label><strong style="color:white;">Menores (5 a 10 años)</strong></label>

            </td>
            <td align="center">

                <div class="select">
                  <select v-model="ninos" @change="cotiza()" >
                    <option value=0>0</option>
                    <option value=1>1</option>
                    <option value=2>2</option>
                    <option value=3>3</option>
                    <option value=4>4</option>
                    <option value=5>5</option>
                  </select>
                </div>
              

            </td>
            </tr>
          <tr v-if="admiteInfante==1">
            <td>

              
                <strong style="color:white;">Infantes (0 a 4 años)</strong>

            </td>
            <td align="center">

                <div class="select">
                  <select v-model="infantes" @change="cotiza()" >
                    <option value=0>0</option>
                    <option value=1>1</option>
                    <option value=2>2</option>
                  </select>
                </div>
              

            </td>
          </tr>
        </tbody>
      </table>

      

    <!-- </div> -->
     <!--
    <div v-if="adultos>0" style="margin-top:-20px; background-color:#F9FFF8; text-align:center; border-radius: 15px; ">
    <span style="color:#565656;" v-if="this.tourInformation.data[0].id!=36">Total ${{cantidadTotal}} MXN</span> <br v-if="adultos>0 && this.tourInformation.data[0].id!=36" >
    <strong style="color:#565656;">RESERVA CON </strong> <strong style="color:#B588DF; font-size:30px;">${{cantidadParaReservar}}</strong> <br v-if="adultos>0">
    <span v-if="this.tourInformation.data[0].id!=36" style="color:#565656;">Liquida el resto al abordar!</span>
    </div>
    -->

    <!-- <button v-if="adultos>0" class="button is-light is-small is-fullwidth" onClick="parent.location='https://www.facebook.com/Exodus-M%C3%A9xico-691083214335683'" target="_blank" style="margin-top:10px;">o solicita aquí el pago de ${{this.cantidadTotalMes}}* MXN/mes en Facebook</button> -->
    <!--
      <div style="text-align:center;" v-if="adultos>0 && this.tourInformation.data[0].id!=36">
        <span class="is-small" style="color:white; text-align:center;"> o ${{this.cantidadTotalMes}} MXN por 12 meses </span>
      </div>
      -->
    <br v-if="adultos>0">
    <strong style="color:white;">Nombre</strong>
    <input v-model="cliente" class="input">

    <strong style="color:white;">e-mail</strong>
    <input v-model="mail" class="input">

    <strong style="color:white;">Teléfono</strong>
    <input v-model="telefono" class="input">

    <br><br>

    <textarea class="textarea" v-model="observaciones" placeholder="Comentarios (opcional)"></textarea>

    <!-- <button class="button" @click="reservar()">Reservar</button> -->

    <p style="color:white; text-align:justify;" v-if="this.tourInformation.data[0].id==36"> Esta reservación sólo será válida con el pago vía transferencia o depósito bancario 7 días antes de la fecha de salida. Cuenta Santander 5579 1002 9345 5935. </p>
    <input v-if="this.tourInformation.data[0].id==36" class="button is-fullwidth" @click="reservar()" type="submit" value="Reserva" :disabled="( this.adultos>0 && this.cliente!='' && this.mail!='' && this.telefono.length>=10 )?false:true" >

    <div v-if="this.tourInformation.data[0].id!=36">
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
  
          <input type="hidden" name="cmd" value="_xclick">
          <input type="hidden" name="business" value="jean@sistemy.mx">
          <input type="hidden" name="item_name" :value="tourInformation.data[0].nombre+' '+getConfirmacion">
          <input type="hidden" name="item_number" :value="tipoName">
          <input type="hidden" name="amount" :value="cantidadParaReservar">
          <!-- <input type="hidden" name="amount" value="1"> -->
      
          <input type="hidden" name="no_shipping" value="0">
          <input type="hidden" name="no_note" value="1">
          <input type="hidden" name="currency_code" value="MXN">
          <input type="hidden" name="lc" value="AU">
          <input type="hidden" name="bn" value="PP-BuyNowBF">
          <input type="hidden" name="return" value="https://net.tutsplus.com/payment-complete/">
      
          <br />
          
          <!-- <br v-if="this.tourInformation.data[0].id==36"> -->
          <!--
          <input class="button is-fullwidth" @click="reservar()" type="submit" value="Cotizar ahora" :disabled="( this.adultos>0 && this.cliente!='' && this.mail!='' && this.telefono.length>=10 )?false:true" >
          -->
          <input class="button is-fullwidth" value="Cotizar ahora"  >
          
          
      </form>
      
      <!--
      <a v-if="adultos>0" class="button is-link is-inverted is-small is-fullwidth" href="https://www.messenger.com/t/691083214335683/?messaging_source=source%3Apages%3Amessage_shortlink&source_id=1441792" target="_blank" style="margin-top:10px;">o solicita en Facebook el pago de ${{this.cantidadTotalMes}}* MXN/mes</a>
      <div style="text-align:center;">
        <router-link :to="'/terminos_condiciones/'" style="color:white;">Al dar click en "Reservar ahora" usted acepta los términos y condiciones.</router-link>
      </div>
      -->
    </div>



  </div>
  </div>
   <div :class="(this.modalConfirmacion)?'modal is-active':'modal'" align="center">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <span class="modal-card-title">
                <strong>Gracias por reservar</strong>
              </span>
              <button class="delete" @click="cerrarModalConfirmacion()" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
              <span v-text="this.cliente"></span>, su número de confirmación es el siguiente
              <strong><span class="is-size-2" v-text="this.confirmacion" ></span></strong>
              <br>
              Hemos enviado el cupón vía correo electrónico. Revise su bandeja principal y/o la de bandeja de spam. Favor de presentarlo junto con el pago de PayPal para hacer válido el servicio.

            </section>
            <footer class="modal-card-foot">
              <button @click="cerrarModalConfirmacion()" class="button is-info is-fullwidth">Entendido</button>
            </footer>
          </div>
        </div>
  </div>
  

 

<!-- </div> -->


</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
  components:{
    DatePick,
    VueClockPicker,
    Carousel3d,
    Slide
  },
  data () {
    return {
      // format: 'DD-MMMM-YYYY',
      subSelect:'',
      toursList:[],
      tiposList:[],
      tiposGeneralesList:[],
      idiomasList:[],
      nacionalidadesList:[],
      salidasList:[],
      tour:'',
      tour2:'',
      tour3:'',
      tour4:'',
      tipo:'',
      nacionalidad:'',
      idioma:'',
      salida:'',
      fecha:'',
      // fecha:moment().add(1, 'day').format('DD-MMMM-YYYY'),
      fecha2:'',
      fecha3:'',
      fecha4:'',
      hora:'',
      searchText:'',
      searchText2:'',
      items:[],
      items2:[],
      hotel:'',
      hotelId:'',
      hotelPickup:'',
      vendedor:'',
      vendedorId:null,
      adultos:0,
      ninos:0,
      infantes:0,
      cliente:'',
      // cliente:'Jean test',
      habitacion:'',
      cupon:'',
      balance:0,
      moneda:null,
      monedasList:[],
      observaciones:'',
      confirma:'',
      servicio:1,
      horario:1,
      cortesia:2,
      testObject:[],
      files: '',
      imagen: null,

      host: 'exodustickets.sistemy.mx',
      tourInformation:[],
      tipoElegido:'',
      servicio:'',

      descripcion:'',
      recomendaciones:'',
      incluye :'',
      noIncluye:'',

      lugarSalida:'',
      horaSalida:'',
      duracion:'',
      mapa:'',

      admiteNino:'',
      admiteInfante:'',

      reportarAdulto:'',
      reportarMenor:'',
      reportarInfante:'',
      reportarInsen:'',
      comisionAdulto:'',
      comisionMenor:'',
      comisionInfante:'',
      comisionInsen:'',
      gananciaAdulto:'',
      gananciaMenor:'',
      gananciaInfante:'',
      gananciaInsen:'',

      diasAnticipacion:'',
      dosPorUno: '',
      activo:'',

      files:'',
      newFileName:'',
      serviceImage:'',
      descripcionImage:'',
      serviceImages: [],
      publicAdult:'',
      pagoMes:'',
      cantidadTotalMes:'',
      publicMenor: '',
      publicInfante: '',
      carouselReady:false,
      nacionalidadId:'1',

      cantidadTotal:'',
      cantidadParaReservar:'',
      cantidadBalance:'',
      telefono:'',
      // telefono:9982420807,
      tipoName:'',
      modalConfirmacion: false
      
      // host: 'localhost'

    }
  },
  created(){
    console.log("path in tour",this.$route.path)
    console.log(this.$route.params.id,'<-- route')
    this.tourInfo();
    
    this.getTiposGenerales();
    this.getServiceImages();
    
    // this.getHoteles();
    // this.getVendedores();
    // this.getMonedas();
    // this.getTours();
    // this.getIdiomas();
    // this.getNacionalidades();
    // this.getSalidas();
  },
  computed:{
    getConfirmacion () {
      // this.confirmacion='WEB'+(this.cliente.substr(0,3)).toUpperCase()+this.tourInformation.data[0].nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+moment().format('HHmm')+'H'+this.adultos+'-'+this.ninos+'EX'.toUpperCase();
      this.confirmacion=(this.cliente.substr(0,2)).toUpperCase()+this.tourInformation.data[0].nombre.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+moment().format('HHmm')+'H'+this.adultos;
      return this.confirmacion
    },
    itemsSearched : function(){
      var self = this;
      if( self.searchText == ''){
        return self.items;
      }
      return self.items.filter(function(item){

        var str = self.searchText;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    },
    itemsSearched2 : function(){
      var self = this;
      if( self.searchText2 == ''){
        return self.items2;
      }
      return self.items2.filter(function(item){

        var str = self.searchText2;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    }
  },
  methods:{

    getAnticipacion (date) {
      // const dias = 0;
      console.log(moment().format('HH'),'time now')
      var hour = moment().format('HH')
      console.log(hour,'hour now')
      var maxHour = 20
      if(hour<maxHour){
        console.log(moment().format('HH'),'time now en if')
        const dias = ((24*60*60*1000)* (this.diasAnticipacion-1) );
        const currentDate = new Date( (new Date).getTime() + dias );
      return date < currentDate;
      }else{
        console.log("en else")
        const dias = ((24*60*60*1000)* (this.diasAnticipacion) );
        const currentDate = new Date( (new Date).getTime() + dias );
      return date < currentDate;
      }
    },
    
    reservar () {
      this.saveBooking()
      if(this.nacionalidadId==1){
        var ine = 'Nacional, No Quintanarroense';
      }else{
        var ine = 'Quintanarroense';
      }
      var params = {
        credencial : ine,
        confirmacion : this.confirmacion,
        servicio: this.tourInformation.data[0].nombre,
        tipo: this.tipoName,
        cliente: this.cliente,
        telefono: this.telefono,
        mail: this.mail,
        lugarSalida: this.lugarSalida,
        horaSalida: this.horaSalida,
        fecha: this.fecha,
        adultos: this.adultos,
        ninos: this.ninos,
        infantes: this.infantes,
        cantidadTotal: this.cantidadTotal,
        cantidadParaReservar: this.cantidadParaReservar,
        cantidadBalance: this.cantidadBalance,
      }
      axios.post(`https://${this.host}/enviarCupon.php`,qs.stringify(params))
          .then((response) => {
            if (response.status == 200 ) {
              console.log("enviado")
            }else{
              console.log('error');
            }
          });
    },
    saveBooking () {
      var params = {
        action : 'insertPost',
        table : 'reservaciones',
        columns : ' fecha, tourId, tipoTourId, salidaId, nacionalidadId, idiomaId, adultos, ninos, infantes, cliente, telefono, mail, hotelId, habitacion, cupon, pickup, vendedorId, paypal, balance, moneda, observaciones, tipoReservacionId, posicionReservacion, claveReservacion, fechaCreado, horaCreado, activo, confirmacion, servicio, cortesia, horario',
        values : ` '${this.fecha}',${this.tourInformation.data[0].id},${this.tipoElegido},1,${this.nacionalidadId},5,${this.adultos},${this.ninos},${this.infantes},'${this.cliente}','${this.telefono}','${this.mail}','','','','${this.horaSalida}',1,${this.cantidadParaReservar},${this.cantidadBalance},1,'${this.observaciones}',1,'','${this.salida+this.adultos+this.cliente+this.hotelId+'WEB'+moment().format('YYYY-MM-DD')}','${moment().format('YYYY-MM-DD')}','${moment().format('HH:mm:ss')}',1,'${this.confirmacion}','','','' `
      }
      axios.post(`https://${this.host}/assignFunction.php`,qs.stringify(params))
       .then( (response) => {
         if (response.status == 200 ) {
           this.modalConfirmacion=true
          
          //  this.$snotify.success('Reservado', 'Correcto', {
          //      timeout: 2000,
          //      showProgressBar: false,
          //      closeOnClick: false,
          //      pauseOnHover: true
          //    });
         }else{
           console.log('error: No reservado');
         }
       });
    },
    paypal () {
      console.log("en PayPal")
      // var params = {
      //   cmd : '_xclick',
      //   business : 'jean@sistemy.mx',
      //   item_name : 'Donation',
      //   item_number : "CHICHEN",
      //   amount : "15",
      //   currency_code : "MXN"
      // }
      // axios.post(`https://api.paypal.com`,{headers:{'Accept': 'application/json','Accept-Language': 'en_US','Content-Type':'application/x-www-form-urlencoded','Access-Control-Allow-Origin': '*',}},qs.stringify(params))
      //  .then(function(response){
      //    if (response.status == 200 ) {
      //      this.paypal();
      //      this.$snotify.success('Reservado', 'Correcto', {
      //          timeout: 2000,
      //          showProgressBar: false,
      //          closeOnClick: false,
      //          pauseOnHover: true
      //        });
      //    }else{
      //      console.log('error: No reservado');
      //    }
      //  });

      (async () => {
  try {
    const { data: { access_token } } = await axios({
      url: 'https://api.paypal.com',
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Accept-Language': 'en_US',
        'content-type': 'application/x-www-form-urlencoded',
      },
      auth: {
        username: 'jean@sistemy.mx',
        password: 'Scarlett.84',
      },
      params: {
        grant_type: 'client_credentials',
      },
    });

    console.log('access_token: ', access_token);
  } catch (error) {
    console.log('error: ', error);
  }
})();
    },
    rates(){
      
      this.publicAdult = parseInt(this.reportarAdulto)+parseInt(this.comisionAdulto)+parseInt(this.gananciaAdulto);
      this.publicMes = parseInt(this.reportarAdulto)+((parseInt(this.comisionAdulto)+parseInt(this.gananciaAdulto))/2);
      this.publicAdultQroo = parseInt(this.reportarAdulto)+((parseInt(this.comisionAdulto)+parseInt(this.gananciaAdulto))/2);
      this.pagoMes = Math.round(this.publicMes/9.84)

      this.publicMenor = parseInt(this.reportarMenor)+parseInt(this.comisionMenor)+parseInt(this.gananciaMenor);

      this.publicInfante = parseInt(this.reportarInfante)+parseInt(this.comisionInfante)+parseInt(this.gananciaInfante);

    },
    cotiza(){
      
      this.cantidadTotal = (this.publicAdult*this.adultos)+(this.publicMenor*this.ninos)+(this.publicInfante*this.infantes)
      this.cantidadTotalMes =  Math.round(((this.publicAdult*this.adultos)+(this.publicMenor*this.ninos)+(this.publicInfante*this.infantes))/9.84)
      this.cantidadParaReservar = ( ( parseInt(this.gananciaAdulto) + parseInt(this.comisionAdulto) ) *this.adultos)+( (parseInt(this.gananciaMenor) + parseInt(this.comisionMenor) ) *this.ninos)+( (parseInt(this.gananciaInfante) + parseInt(this.comisionInfante) ) *this.infantes)

      if(this.nacionalidadId==3){
        this.cantidadTotal = ( ( parseInt(this.reportarAdulto)+parseInt(this.comisionAdulto/2)+parseInt(this.gananciaAdulto/2) )*this.adultos)+(this.publicMenor*this.ninos)+(this.publicInfante*this.infantes)
        this.cantidadTotalMes =  Math.round((( ( parseInt(this.reportarAdulto)+parseInt(this.comisionAdulto/2)+parseInt(this.gananciaAdulto/2) )*this.adultos)+(this.publicMenor*this.ninos)+(this.publicInfante*this.infantes))/9.84)
        this.cantidadParaReservar = ( ( parseInt(this.gananciaAdulto/2) + parseInt(this.comisionAdulto/2) ) *this.adultos)+( (parseInt(this.gananciaMenor) + parseInt(this.comisionMenor) ) *this.ninos)+( (parseInt(this.gananciaInfante) + parseInt(this.comisionInfante) ) *this.infantes)
      }

      this.cantidadBalance = this.cantidadTotal -  this.cantidadParaReservar
      if(this.dosPorUno==1){
        this.cantidadTotal = this.cantidadTotal/2
        this.cantidadParaReservar = this.cantidadParaReservar/2
        this.cantidadBalance = this.cantidadBalance/2
      }
    },
    eliminarArchivo (id) {

      var params = {
        action: 'justUpdate',
        tabla: 'services_images',
        set: 'status = 2',
        where: 'id = '+id
      }
      axios.post(`https://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response) => {
            if (response.status == 200 ) {
              console.log("eliminado & status 200")
              this.getServiceImages()
            }else{
              console.log('error');
            }
          });

    },
    getServiceImages(){
      console.log("En getServiceImages");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'services_images',
          where: 'status = 1 and servicio = '+this.$route.params.id+' order by id desc'
      }
          axios.post(`https://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ console.log(response,'<-- response de getServiceImages')
         if (response.status == 200 ) {
          console.log("bien getServiceImages");
          this.serviceImages=response.data
          this.carouselReady = true
         }else{
           console.log('error: no se obtuvieron las imágenes');
         }
       });

    },
    handleFileUploads(){
      this.files = this.$refs.files.files;
      console.log(files,'files')
    },
    submitFiles2(){
        
        for( var i = 0; i < this.files.length; i++ ){
          
          this.newFileName = moment().format('YYYYMMDD')+moment().format('HHmmss')+this.files[i].name
          this.serviceImage = 1 //Aquí va el id del servicio q se está editando
          this.descripcionImage = this.files[i].name
          this.saveFileData();
          var data = new FormData();
          data.append("nombre",this.newFileName)
          data.append("foto",this.files[i])
          axios.post(`https://${this.host}/loadServiceImage.php`,data)
          .then(response => {
            
          })

        }

      },
      saveFileData () {
        console.log('saveFileData')
      var params = {
        action : 'insertPost',
        table : 'services_images',
        columns : 'user, fecha, hora, nombre, descripcion, servicio, status',
        values : ` ${$cookies.get('RhSession').id}, '${moment().format('YYYY-MM-DD')}', '${moment().format('HH:mm:ss')}', '${this.newFileName}', '${this.descripcionImage}', '${this.$route.params.id}', 1 `
      }
      axios.post(`https://${this.host}/assignFunction.php`,qs.stringify(params))
       .then((response)=>{
         if (response.status == 200 ) {
          //this.getCloudFileNames()
          this.getServiceImages()
          this.descripcionImage = ''
          this.imagen = ''
          this.newFileName = ''
          this.cargando = false
           this.$snotify.success('Guardado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
    },
    clear () {
      this.adultos = 0
      this.ninos = 0
      this.infantes = 0
      this.cliente = ''
      this.mail = ''
      this.telefono = ''
      this.observaciones = ''
    },
    setTipo(id,index){
      this.adultos = 0
      this.ninos = 0
      this.infantes = 0
      this.cantidadTotal = 0
      this.cantidadParaReservar = 0
      this.cantidadBalance = 0
      this.subSelect = index
      this.tipoElegido = id;
      this.tipoName = this.tiposList[index].nombre
      this.getServicio(id,this.$route.params.id)
      console.log(id,index,this.tipoName,'id,index,tipoName')
    },
    tourInfo(){
      console.log("En tourInfo()");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'tour',
          where: 'id='+this.$route.params.id
      }
          axios.post(`https://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ 
         if (response.status == 200 ) {
         this.tourInformation=response
         this.getTipos();
          //  this.$snotify.success('test', 'Correcto', {
          //      timeout: 4000,
          //      showProgressBar: false,
          //      closeOnClick: false,
          //      pauseOnHover: true
          //    });
         }else{
           console.log('error: No reservado');
         }
       });

    },
    fechas (r) {
      // if(r==2){
      //   this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      // }else if (r==3){
      //   this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      //   this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
      // }else if(r==4){
      //   this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      //   this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
      //   this.fecha4=moment().add(4, 'days').format('YYYY-MM-DD');
      // }
    },
    
    elegido:function(item){
      this.searchText='';
      this.hotel = item.nombre;
      this.hotelId = item.id;
      this.hotelPickup = item.pickup;
      console.log(this.tour.pickup,'tour.pickup');
      console.log(item,'item');
      if(this.tour.pickup=='' || this.tour.pickup==null ){
        this.hora=item.pickup;
      }
    },
    elegido2:function(item){
      this.searchText2='';
      this.vendedor = item.nombre;
      this.vendedorId = item.id;
    },
    getHoteles(){
      var estancia = this;
        var select = `id, nombre, pickup`;
        var tabla = "hoteles";
        var where = "";
        axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            // estancia.hotelesList  = response.data;
            estancia.items = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getMonedas(){
      var estancia = this;
        var select = `id, nombre`;
        var tabla = "monedas";
        var where = "";
        axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.monedasList = response.data;
            estancia.moneda=response.data[0].id;
          }else{
            console.log('error');
          }
        });
    },
    getVendedores(){
      var estancia = this;
        var select = `id, nombre`;
        var tabla = "vendedores";
        var where = "activo=1";
        axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.items2 = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getTours(){
      var estancia=this;
      var select = `*`;
      var tabla = "tour";
      var where = "";
      axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.toursList=response.data;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getTipos(){
      console.log('en getTipos');
      // this.hora=this.tour.pickup;
      // console.log(this.hora,'hora');
      console.log(this.tourInformation.data[0].tipoBasico,'checking')
      if(this.tourInformation.data[0].tipoBasico!=2){ //Valida que el tour no deba tener tipos
        var estancia=this;
        var select = `*`;
        var tabla = "tipo";
        if(this.tourInformation.data[0].tipoBasico==1){ // Valida que el tour deba tener los tipos básico y plus
          var where = ` tourId like '%25%2C${this.$route.params.id}%2C%25' or tourId like '0'  `;
        }else{ // Hace esto en caso de que el tour no deba tener los tipo básico y plus
          var where = ` tourId like '%25%2C${this.$route.params.id}%2C%25' `;
        }
        axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then((response)=>{
            console.log(response,'response')
            if (response.status == 200 ) {
                this.tiposList=response.data;

                // this.tiposList[0].id
                // console.log(estancia.tiposList,'tiposList')
                // console.log(this.tourInformation.data[0].tipoBasico,'tipoBasico afterResponse')
                // console.log(this.tiposList[0].id,'primer tipo en la lista')
                
                this.tipoElegido = this.tiposList[0].id
                this.tipoName = this.tiposList[0].nombre
                this.getServicio(this.tipoElegido,this.tourInformation.data[0].id)
                
            }else{
              console.log('error getTours');
            }
          }); //ends axios
      }else{
        console.log('panda')
        this.tipoElegido=0;
        this.getServicio(this.tipoElegido,this.tourInformation.data[0].id)
      }
    },
    getTiposGenerales(){
        var estancia=this;
        var select = `*`;
        var tabla = "tipo";
        var where = "tourId = '0'";
        axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposGeneralesList=response.data;
                if(estancia.tipo==''){
                // if(estancia.tipo=='' || (estancia.tiposList.length<1 && tour.id==6) ){
                 estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    getServicio(tipo,tour){
      if(tipo==''){
        tipo=0
      }
      console.log(tipo,tour,'tipo,tour')
      var estancia=this;
        var select = `*`;
        // var tabla = "tipo";
        var tabla = "servicios";
        var where = `tourId = ${tour} and tipoId = ${tipo}`;
        axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then((response)=>{
            if (response.status == 200 ) {
              console.log(response.data[0].descripcion,'desc')
                this.servicio=response.data[0];
                console.log(response.data[0],"<-- servicio has")
                this.descripcion = response.data[0].descripcion
                this.recomendaciones = response.data[0].recomendaciones
                this.incluye = response.data[0].incluye
                this.noIncluye = response.data[0].noIncluye

                this.lugarSalida = response.data[0].lugarSalida
                this.horaSalida = response.data[0].horaSalida
                this.duracion = response.data[0].duracion
                this.mapa = response.data[0].mapa
                
                this.admiteInfante = response.data[0].admiteInfante
                this.admiteNino = response.data[0].admiteNino

                this.reportarAdulto = response.data[0].reportarAdulto
                this.reportarMenor = response.data[0].reportarMenor
                this.reportarInfante = response.data[0].reportarInfante
                this.reportarInsen = response.data[0].reportarInsen
                this.comisionAdulto = response.data[0].comisionAdulto
                this.comisionMenor = response.data[0].comisionMenor
                this.comisionInfante = response.data[0].comisionInfante
                this.comisionInsen = response.data[0].comisionInsen
                this.gananciaAdulto = response.data[0].gananciaAdulto
                this.gananciaMenor = response.data[0].gananciaMenor
                this.gananciaInfante = response.data[0].gananciaInfante
                this.gananciaInsen = response.data[0].gananciaInsen

                this.diasAnticipacion = response.data[0].diasAnticipacion

                if( moment().format('HH')<20 ){
                  this.fecha = moment().add( (response.data[0].diasAnticipacion), 'day').format('YYYY-MM-DD')
                }else{
                  var dia = parseInt(response.data[0].diasAnticipacion)+1
                  console.log(dia,'diaaaaaaaaaaaa')
                  this.fecha = moment().add( (dia), 'day').format('YYYY-MM-DD')
                }

                // this.fecha = moment().add( (response.data[0].diasAnticipacion), 'day').format('YYYY-MM-DD')
                this.dosPorUno = response.data[0].dosPorUno
                this.activo = response.data[0].activo
                console.log(response.data[0].activo,"activo")

                this.rates();

                console.log(this.servicio,'servicio')
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    upsertServicio(){

      var params = {
        action : 'upsert',
        request : "INSERT INTO servicios(tourId,tipoId,descripcion,recomendaciones,incluye,noIncluye,lugarSalida,horaSalida,duracion,mapa,reportarAdulto,reportarMenor,reportarInfante,reportarInsen,comisionAdulto,comisionMenor,comisionInfante,comisionInsen,gananciaAdulto,gananciaMenor,gananciaInfante,gananciaInsen,diasAnticipacion,activo ) values("
        +this.$route.params.id+", "+this.tipoElegido+",'"+this.descripcion+"','"+this.recomendaciones+"','"+this.incluye+"','"+this.noIncluye+"','"+this.lugarSalida+"','"+this.horaSalida+"','"+this.duracion+"','"+this.mapa+"','"+this.reportarAdulto+"','"+this.reportarMenor+"','"+this.reportarInfante+"','"+this.reportarInsen+"','"+this.comisionAdulto+"','"+this.comisionMenor+"','"+this.comisionInfante+"','"+this.comisionInsen+"','"+this.gananciaAdulto+"','"+this.gananciaMenor+"','"+this.gananciaInfante+"','"+this.gananciaInsen+"','"+this.diasAnticipacion+"','"+this.activo+
        "') on duplicate key update tourId=values(`tourId`), tipoId=values(`tipoId`), descripcion=values(`descripcion`), recomendaciones=values(`recomendaciones`), incluye=values(`incluye`), noIncluye=values(`noIncluye`), lugarSalida=values(`lugarSalida`), horaSalida=values(`horaSalida`), duracion=values(`duracion`), mapa=values(`mapa`), reportarAdulto=values(`reportarAdulto`), reportarMenor=values(`reportarMenor`), reportarInfante=values(`reportarInfante`), reportarInsen=values(`reportarInsen`), comisionAdulto=values(`comisionAdulto`), comisionMenor=values(`comisionMenor`), comisionInfante=values(`comisionInfante`), comisionInsen=values(`comisionInsen`), gananciaAdulto=values(`gananciaAdulto`), gananciaMenor=values(`gananciaMenor`), gananciaInfante=values(`gananciaInfante`), gananciaInsen=values(`gananciaInsen`), diasAnticipacion=values(`diasAnticipacion`), activo=values(`activo`) "
      }
      axios.post(`https://${this.host}/assignFunction.php`,qs.stringify(params))
       .then((response)=>{
         if (response.status == 200 ) {
           this.$snotify.success('Upsert', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No guardado en la tabla');
         }
       });

    },
    getIdiomas(){
      var estancia=this;
      var select = `*`;
      var tabla = "idioma";
      var where = ``;
      axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.idiomasList=response.data;
              estancia.idioma=response.data[4].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getSalidas(){
      var estancia=this;
      var select = `*`;
      var tabla = "lugar_salida";
      var where = ``;
      axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.salidasList=response.data;
              estancia.salida=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getNacionalidades(){
      var estancia=this;
      var select = `*`;
      var tabla = "nacionalidad";
      var where = ``;
      axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.nacionalidadesList=response.data;
              estancia.nacionalidad=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    tipoCuponF(n){
      if(this.tipoCupon==1){
        $("#1").addClass("is-active");
      }
      if(n==2){
        $("#2").addClass("is-active");
      }
      if(n==3){
        $("#3").addClass("is-active");
      }
      if(n==4){
        $("#4").addClass("is-active");
      }
      this.tipoCupon=n;
    },
    cerrarModalConfirmacion:function(){
      this.modalConfirmacion=false
      this.clear();
      // $("#modalConfirmacion").removeClass("is-active");
    },
  },
  mixins: [searchMix]
}
</script>
